// test417
(417 && 0);
